<template>
  <div class="question">
    <span v-if="simple">
      <p>
        <b> Вопрос № {{ questionNumber }}: </b>
      </p>
    </span>
    <p style="text-indent: 20px; text-align: justify; text-justify: inter-word;  white-space: normal;">
      {{ questionText }}
    </p>
    <span v-if="hasImage">
      <el-row style="text-align:center">
        <img v-bind:src="imageUrl" style="height: auto; max-height:500px; width: auto; object-fit: contain; float:both;">
      </el-row>
    </span>
    <span v-if="simple">
      <span v-if="open">
        <p>
          <b> Введите ответ: </b>
        </p>
        <el-input
          type="textarea"
          :rows="4"
          v-model="openAnswer"
          @change="input">
        </el-input>
      </span>
      <span v-else>
        <p>
          <b> Варианты ответов: </b>
        </p>
        <span v-for="answer in answers">
          <p style="margin-top:-10px;">
            <span v-if="multiple">
               <el-checkbox v-bind:id="'answer'+answer.uid" v-model="answer.checked" @change="change(answer.uid)" style="text-align: justify; text-justify: inter-word; padding: 20px 0px 10px 0px; white-space: normal; font-size: 1rem !important;">{{answer.orderNumber}}. {{answer.text}}</el-checkbox>
            </span>
            <span v-else>
              <el-button v-bind:id="'answer'+answer.uid" type="text" @click="select(answer.uid)" style="text-align: justify; text-justify: inter-word; padding: 20px 0px 10px 0px; white-space: normal; font-size: 1rem;">{{answer.orderNumber}}. {{answer.text}}</el-button>
            </span>
          </p>
        </span>
      </span>
    </span>
    <span v-else-if="psycho" class="psycho-controls">
      <el-row style="height:100%">
        <span v-for="answer in answers">
            <el-button v-bind:id="'answer'+answer.id" @click="check(answer.id)" style="height:100%; text-align:center;">{{answer.order}}</el-button>
        </span>
      </el-row>
    </span>
    <span v-if="simple">
      <p>
        <b> Обоснование: </b>
      </p>
      <p style="text-indent: 20px; text-align: justify; text-justify: inter-word;  white-space: normal;">
        {{ questionDescription }}
      </p>
    </span>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import { mapGetters, mapActions } from 'vuex'

  export default {
      name: 'question',
      data() {
        return {
          openAnswer: null,
          copiedAnswers: []
        }
      },
      methods: {
        select(id) {
          if(id) {
            this.singleAnswer(id);
            this.onRefresh();
          }
        },
        check(id) {
          if(id) {
            this.singleAnswer(id);
            this.next();
          }
        },
        change(id) {
          if(id) {
            this.answer(id);
            this.onRefresh();
          }
        },
        input(value) {
          this.inputAnswer(value);
        },
        next() {
          //TODO: save question
          this.resetAnswer();
          this.nextState(false);
          this.toState(this.currentState);
        },
        toState(state) {
          if(state) {
              const path = state.path;
              if(path)
                this.$router.push(path);
              else
                this.finish();
          } else
            this.finish();
        },
        finish() {
          //TODO: finish scenario
          this.exit();
          this.$router.push(config.WELCOME_URL);
        },
        highlightLink(id) {
          if(id) {
            if(this.answers) {
              this.answers.forEach(function(item, i, answers) {
                let aId = item.uid;
                let color = '#20a0ff';
                let weight = 'normal';
                if(id && (aId === id)) {
                  color = '#1f2f3d';
                  weight = 'bold';
                }
                let element = document.getElementById('answer' + aId);
                if(element) {
                  element.style['color'] = color;
                  element.style['font-weight'] = weight;
                }
              });
            }
          }
        },
        onRefresh() {
          //this.copyAnswers();
          if(this.answers) {
            let aLength = this.answers.length;
            if(aLength) {
              if(this.simple) {
                if(this.multiple) {
                  for(var i = 0; i < aLength; i++) {
                    let color = '#20a0ff';
                    let weight = 'normal';
                    let aId = this.answers[i].uid;
                    let checked = false;
                    if(this.checkedAnswers) {
                      let acLength =  this.checkedAnswers.length;
                      if(acLength) {
                        for(var j = 0; j < acLength; j++) {
                          if(aId === this.checkedAnswers[j]) {
                            color = '#1f2f3d';
                            weight = 'bold';
                            checked = true;
                            this.answers[i].checked = true;
                          }
                        }
                      }
                    }
                    let element = document.getElementById('answer' + aId);
                    if(element) {
                      element.style['color'] = color;
                      element.style['font-weight'] = weight;
                      //element.children[0].className = checked ? 'el-checkbox__input is-checked' : 'el-checkbox__input'
                      //element.control.checked = checked;
                    }
                  }
                } else if (this.open) {
                  this.openAnswer = this.inputedAnswer;
                } else {
                  if(this.checkedAnswers && this.checkedAnswers.length) {
                    this.highlightLink(this.checkedAnswers[0]);
                  } else {
                    this.answers.forEach(function(item, i, answers) {
                      let aId = item.uid;
                      let color = '#20a0ff';
                      let weight = 'normal';
                      let element = document.getElementById('answer' + aId);
                      if(element) {
                        element.style['color'] = color;
                        element.style['font-weight'] = weight;
                      }
                    });
                  }
                }
              } else if(this.psycho) {
                  let width = 100 / aLength;
                  for(var i = 0; i < aLength; i++) {
                      let aId = this.answers[i].uid;
                      let element = document.getElementById('answer' + aId);
                      if(element) {
                        element.style['width'] = width + '%';
                      }
                  }
              }
            }
          }
        },
        copyAnswers() {
          this.copiedAnswers = [];
          if(this.answers) {
            let aLength = this.answers.length;
            if(aLength) {
              for (var i = 0; i < aLength; i++) {
                let instance = this.answers[i];
                this.copiedAnswers[i] = { uid : instance.uid, orderNumber : instance.orderNumber, text : instance.text, checked : instance.checked };
              }
            }
          }
        },
        ...mapActions([
          'exit',
          'nextState',
          'answer',
          'singleAnswer',
          'resetAnswer',
          'inputAnswer'
        ])
      },
      computed: {
        simple: function() {
          return this.isSimple;
        },
        multiple: function() {
          return this.isMultiple;
        },
        open: function() {
          return this.isOpen;
        },
        psycho: function() {
          return this.isPsycho;
        },
        hasImage: function() {
          return this.questionImage;
        },
        imageUrl: function() {
          //return 'https://img00.deviantart.net/a4c9/i/2015/305/b/1/harley_quinn___margot_robbie_h_q_wallpaper_by_iamuday-d9f81u6.jpg';
          //return 'https://im0-tub-ru.yandex.net/i?id=cee7de01663168bf2ec0321dff3fcc6f-l&n=13';
          return this.questionImage;
        },
        ...mapGetters([
          'currentState',
          'checkedAnswers',
          'inputedAnswer',
          'isSimple',
          'isMultiple',
          'isOpen',
          'isPsycho',
          'isContestAuthorized',
          'questionNumber',
          'questionText',
          'questionDescription',
          'questionImage',
          'answers'
        ])
      },
      /*watch: {
        copiedAnswers: function(value) {
          this.onRefresh();
        }
      },*/
      created: function() {
        if(!this.isContestAuthorized)
          this.$router.push(config.WELCOME_URL);
      },
      mounted: function() {
        if(this.isContestAuthorized) {
          Event.$on('newQuestionAsked', () => {
            this.onRefresh();
          });
          this.onRefresh();
        }
      },
      beforeDestroy() {
        Event.$off('newQuestionAsked');
      }
  }
</script>

<style scoped>
  .question {
    height: calc(100% - 35px) !important;
  }
  .psycho-controls {
    position: absolute !important;
    bottom: 20px !important;
    left: 20px !important;
    right: 20px !important;
    height: 60px !important;
  }
</style>
<style>
  .el-checkbox .el-checkbox__label {
    font-size: 1rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/contest/question.vue